const KEY = "reelgrab_ig_cookies";
const PARTS_KEY = "reelgrab_ig_cookies_parts";

// Legacy: raw cookie string that gets POSTed to backend
export function getCookies() {
  return localStorage.getItem(KEY) || "";
}

export function hasCookies() {
  return !!getCookies();
}

// Structured parts editor state {sessionid, ds_user_id, csrftoken}
export function getCookieParts() {
  try {
    const raw = localStorage.getItem(PARTS_KEY);
    if (raw) return JSON.parse(raw);
  } catch {}
  // Backwards-compat: parse the legacy raw string if present
  const rawStr = getCookies();
  const parts = { sessionid: "", ds_user_id: "", csrftoken: "" };
  if (rawStr) {
    rawStr.split(";").forEach((chunk) => {
      const [k, ...rest] = chunk.trim().split("=");
      if (!k) return;
      const key = k.trim();
      const val = rest.join("=").trim();
      if (key in parts) parts[key] = val;
    });
  }
  return parts;
}

// Strip surrounding whitespace and quotes; DevTools sometimes wraps in quotes
function clean(v) {
  return (v || "").trim().replace(/^["']|["']$/g, "");
}

export function saveCookieParts(parts) {
  const cleaned = {
    sessionid: clean(parts?.sessionid),
    ds_user_id: clean(parts?.ds_user_id),
    csrftoken: clean(parts?.csrftoken),
  };

  const combined = Object.entries(cleaned)
    .filter(([, v]) => v)
    .map(([k, v]) => `${k}=${v}`)
    .join("; ");

  if (!combined) {
    localStorage.removeItem(KEY);
    localStorage.removeItem(PARTS_KEY);
  } else {
    localStorage.setItem(KEY, combined);
    localStorage.setItem(PARTS_KEY, JSON.stringify(cleaned));
  }
  return combined;
}
